import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { FilesService } from 'src/app/core/services/files.service';
import { SessionStorageService } from 'src/app/core/services/session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SecureDataSharingResolver implements Resolve<any[]> {
  constructor(
    private filesService: FilesService,
    private sessionStorage: SessionStorageService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any[]> {
    const managementUser = this.sessionStorage.userData();
    if (!managementUser || !managementUser.userID) {
      return of([]);
    }
    return this.filesService.getUserFiles(managementUser.userID);
  }
}
